jQuery(function ($) {
    const langViSelect2 = {
      inputTooLong:function(n){return"Vui lòng xóa bớt "+(n.input.length-n.maximum)+" ký tự"},inputTooShort:function(n){return"Vui lòng nhập thêm từ "+(n.minimum-n.input.length)+" ký tự trở lên"},loadingMore:function(){return"Đang lấy thêm kết quả…"},maximumSelected:function(n){return"Chỉ có thể chọn được "+n.maximum+" lựa chọn"},noResults:function(){return"Không tìm thấy kết quả"},searching:function(){return"Đang tìm…"},removeAllItems:function(){return"Xóa tất cả các mục"}
    };
    const updateUrl = (type = '') => {
      const urlSearch = new URLSearchParams(window.location.search);
      urlSearch.set('type', type);
      const qstr = urlSearch.toString();
      let url = window.location.origin + window.location.pathname;
      if(qstr) {
        url += '?' + qstr;
      }
      setTimeout(function () {
        history.replaceState({}, '', url);
      }, 500);
    }
    const searchTypeChange = (id, $ele) => {
            $(`li.store-locator-row`, $ele).removeClass('hidden');
            $(`li.store-locator-row:not([data-type="${id}"])`, $ele).addClass('hidden');
            $('.location-list').each(function() {
              const originalChildLenght = $(this).find('li.store-locator-row').length;
              const originalChildAfterFilterLenght = $(this).find('li.store-locator-row.hidden').length;
              if (originalChildLenght === originalChildAfterFilterLenght) {
                $(this).closest('.location-by-province').addClass('hidden');
              }
            })
    }
    const initStoreLocator = function ($ele) {
        const $parentElement = $('.store-locator-list', $ele);
        const $provinceElement = $('.store-locator__search-province-select', $ele);
        const $districtElement = $('.store-locator__search-district-select', $ele);
        let provinceValue = '';
        $('select.store-locator__search-province-select', $ele).select2({
            language: langViSelect2,
             placeholder: window.SELECT_PROVINCE_PLACEHOLDER,
            allowClear: true
        });
      $('select.store-locator__search-district-select', $ele).select2({
            language: langViSelect2,
             placeholder: window.SELECT_DISTRICT_PLACEHOLDER,
            allowClear: true
        });
        $('.store-locator__search-type button', $ele).click(function(ev) {
          ev.preventDefault();
          const {value} = $(this).data();
          $('.store-locator__search-type button', $ele).removeClass('active');
            $(this).addClass('active');
            if (value) {
              searchTypeChange(value, $ele);
            } else {
              $(`li.store-locator-row`, $ele).removeClass('hidden');
             $('.location-by-province').removeClass('hidden');
            }
          updateUrl(value)
        });
        const callbackProvinceSelect = (e) => {
            const data = e.params.data;
            const {id, text} = data;
            if (id == 0) {
                provinceValue = '';
                $parentElement.find('.location-by-province, .location-by-province ul, .location-by-province ul li').show();
            } else {
                provinceValue = text;
                $parentElement.find('.location-by-province, .location-by-province ul').not(`[data-province="${text}"]`).hide();
                $parentElement.find(`.location-by-province[data-province="${text}"], .location-by-province ul[data-province="${text}"]`).show();
            }
            $districtElement.empty();
            if (Object.hasOwn(window.DISTRICTS, id)) {
                window.DISTRICTS[id].forEach(function (district) {
                    $districtElement.append(`<option value="${district.code}">${district.name}</option>`);
                });
                $districtElement.val(null).trigger('change')
            }
        }
        const callbackDistrictSelect = (e) => {
            const data = e.params.data;
            const {id, text} = data;
            if (id == 0) {
              $parentElement.find(`[data-province="${provinceValue}"]`).show();
            } else {
              $parentElement.find(`.location-by-province ul[data-province="${provinceValue}"] > li[data-province="${provinceValue}"]`).not(`[data-district="${text}"]`).hide();
              $parentElement.find(`.location-by-province ul[data-province="${provinceValue}"] > li[data-province="${provinceValue}"][data-district="${text}"]`).show();
            }
        }
      const callbackProvinceClear = (e) => {
        provinceValue = '';
        $parentElement.find('.location-by-province, .location-by-province ul, .location-by-province ul li').show();
        $districtElement.val(null).trigger('change')
      }
      const callbackDistrictClear = (e) => {
         $parentElement.find(`[data-province="${provinceValue}"]`).show();
      }
        $provinceElement.off('select2:select', callbackProvinceSelect).on('select2:select', callbackProvinceSelect);
      $provinceElement.off('select2:unselect', callbackProvinceClear).on('select2:unselect', callbackProvinceClear);
        $districtElement.off('select2:select', callbackDistrictSelect).on('select2:select', callbackDistrictSelect);
      $districtElement.off('select2:unselect', callbackDistrictClear).on('select2:unselect', callbackDistrictClear);

      $provinceElement.val(null).trigger('change');
      const urlSearch = new URLSearchParams(window.location.search);
      if (urlSearch.get('type')) {
        $(`.store-locator__search-type button[data-value="${id}"]`, $ele).addClass('active');
        searchTypeChange(urlSearch.get('type'), $ele);
      } else {
        $(`.store-locator__search-type button[data-value=""]`, $ele).addClass('active');
      }
    }
    $('.store-locator-wrapper').each(function () {
        if ($(this).attr('initialized') == 1) return;
        initStoreLocator($(this));
        $(this).attr('initialized', 1);
    });
});
